import * as React from "react";
const NewsBell = (props) => (
  <svg
    width={18}
    height={21}
    viewBox="0 0 18 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.84998 0C4.45442 0 1.82724 2.97603 2.24841 6.34536L2.32776 6.98021C2.44388 7.90916 2.10455 8.83706 1.41654 9.47195C-0.00913656 10.7875 -0.405232 12.8815 0.441418 14.6269L0.544769 14.84C1.29088 16.3782 2.80582 17.3855 4.49702 17.4908L4.6853 17.8136C5.6981 19.5498 7.2761 20.5 8.93314 20.5C10.5902 20.5 12.1682 19.5498 13.181 17.8136L13.3722 17.4858C14.793 17.3736 16.0884 16.6014 16.8611 15.3873C18.0432 13.5299 17.7301 11.0932 16.1168 9.59496L16.0729 9.5542C15.8763 9.37158 15.7063 9.16688 15.5651 8.9459C15.342 8.5969 14.8782 8.49484 14.5292 8.71793C14.1802 8.94103 14.0781 9.4048 14.3012 9.7538C14.5102 10.0807 14.7616 10.3835 15.0522 10.6533L15.0961 10.6941C16.1789 11.6997 16.3891 13.3352 15.5956 14.582C15.0335 15.4652 14.0592 16 13.0123 16H12.9474C12.9446 15.9999 12.9417 15.9999 12.9389 15.9999C12.9327 15.9999 12.9265 15.9999 12.9203 16H4.94595C4.93695 15.9998 4.92793 15.9998 4.91891 16H4.79147C3.5579 16 2.43275 15.2952 1.89438 14.1853L1.79102 13.9723C1.23294 12.8218 1.49404 11.4415 2.43379 10.5743C3.47755 9.61114 3.99234 8.20345 3.81618 6.79416L3.73682 6.15931C3.42757 3.68526 5.35667 1.5 7.84998 1.5H9.55289C10.6714 1.5 11.6742 1.93763 12.4155 2.6447C12.7152 2.93058 13.19 2.91934 13.4759 2.61959C13.7617 2.31985 13.7505 1.84511 13.4508 1.55923C12.4426 0.597744 11.0735 0 9.55289 0H7.84998ZM8.93314 19C8.012 19 7.02922 18.5377 6.26988 17.5H11.5964C10.8371 18.5377 9.85427 19 8.93314 19Z"
      fill="#184548"
    />
    <path
      d="M15.9333 5.75C15.9333 6.85457 15.0378 7.75 13.9333 7.75C12.8287 7.75 11.9333 6.85457 11.9333 5.75C11.9333 4.64543 12.8287 3.75 13.9333 3.75C15.0378 3.75 15.9333 4.64543 15.9333 5.75Z"
      fill="#184548"
    />
  </svg>
);
export default NewsBell;
